import { ChangeCardStatus } from "./ChangeCardStatus";
import { RevenueOverview } from "../../types/earnings";
import calcDifference from "../../utils/helpers/calcDifference";

export interface EarningsChangeProps {
  data: RevenueOverview;
  selectedPeriod?: string;
}

export function EarningsChange({ data, selectedPeriod }: EarningsChangeProps) {
  return (
    <ChangeCardStatus change={calcDifference(data.totalThisPeriod, data.totalPrevPeriod)} timespan={selectedPeriod} />
  );
}